
<span class="material-icons">{{icon}}</span>
<span class="menu-item" istag="menuitem">{{label}}</span>
<span class="material-icons" *ngIf="this.comp.widgets.get(this.id)['ischildren']">
    {{renderDirection=='horizontal'? 'expand_more':'chevron_right'}}
</span>

<div class="child-container">
    <ng-template #children></ng-template>
</div>